import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AppService } from '../app.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  hidePassword = true;

 public btndisable:boolean=false;
public ErrorMessage:string="";
  public row: any[] = [];
public add:any={};
  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private router: Router,
    public appservice: AppService
  ) {}

  
// getlogin() {
//   if(!this.validate()){
//     this.toastr.warning(this.ErrorMessage);
//     return;
//   }
//   console.log("token is "+this.appservice.token);
//   this.appservice.getTable("api/LOGIN/getlogin?Username=" + this.add.UserName + "&Password=" + this.add.Password)
//     .subscribe((res: any) => {
//       if (res != "") {
//         this.row = JSON.parse(res).record; 
//         this.appservice.username=this.row[0]["Um_UserName"];
//        this.toastr.success('login Successfully', 'success');
//         this.router.navigate(['/home']);
//         //🔴 Potentially unsafe if res is already a JSON object
//       } else {
//         console.log("there is no data in that user name");
        
//       }
//     });
//     this.toastr.error('Login Fail', 'Error');
//   console.log("token is "+this.appservice.token);}
    validate(){
    if(this.add.UserName==undefined||this.add.UserName==''){
      this.ErrorMessage="Please enter the UserName";
      return false;
    }
    if(this.add.Password==undefined||this.add.Password==''){
      this.ErrorMessage="Please enter the Password";
      return false;
    }
    return true;
   }

 getlogin() {
    if (!this.validate()) {
      this.toastr.warning(this.ErrorMessage);
      return;
    }
this.btndisable=true;
    this.appservice.getTable(
      `api/LOGIN/getlogin?Username=${this.add.UserName}&Password=${this.add.Password}`
    ).subscribe(
      (res: any) => {
        this.btndisable=false;
        if (res != "") {
          const result = JSON.parse(res);
          if (result.record && result.record.length > 0) {
            this.appservice.username = result.record[0]["Um_UserName"];
            this.appservice.CheckerID = result.record[0]["Um_Empcode"];
            this.appservice.Rights = result.record[0]["Um_Rights"];
            this.appservice.RequesterName = result.record[0]["Em_First_Name"]+ " "+result.record[0]["Em_lastName"]+"-"+result.record[0]["Em_Department"];
            this.toastr.success('Login Successfully', 'Success');
            this.router.navigate(['/home']);
          } else {
            this.toastr.error('Invalid username or password', 'Login Failed');
          }
        } else {
          this.toastr.error('No user found', 'Login Failed');
        }
      },
      (err) => {
        console.error(err);
        this.toastr.error('Server error', 'Error');
      }
    );
  }
  onSubmit() {
    // if (this.loginForm.invalid) {
    //   this.toastr.warning('Please fill in all required fields', 'Validation');
    //   return;
    }
 
    // const email = this.loginForm.get('email')?.value;
    // const password = this.loginForm.get('password')?.value;

    // console.log("Sending to API:", email, password);

    // this.appservice
      // .getTable(`api/LOGIN/getlogin?username=${email}&password=${password}`)
      // .subscribe(
      //   (res: any) => {
      //     let data = res;

      //     // backend may send string JSON
      //     if (typeof res === 'string') {
      //       try {
      //         data = JSON.parse(res);
      //       } catch {
      //         this.toastr.error('Invalid response from server', 'Error');
      //         return;
      //       }
      //     }

      //     if (data && data.record && data.record.length > 0) {
      //       this.row = data.record;
      //       this.appservice.username = this.row[0]["um_username"];
      //       this.toastr.success('Login Successfully', 'Success');
           
      //     } else {
      //       this.toastr.error('Login Fail', 'Error');
      //       console.log("No user found for given username/password");
      //     }
      //   },
      //   (err) => {
      //     console.error("API error:", err);
      //     this.toastr.error('Server error', 'Error');
      //   }
      // ); 
      //this.router.navigate(['/home']);
  

  ngOnInit(): void {}
}
